const STORAGE_KEY = "cat:wishlist";
const LEGACY_STORAGE_KEY = "adoc:wishlist";
const SHARE_PARAM = "wishlist";
const toggleSelector = "[data-cat-wishlist-toggle]";
const listSelector = "[data-cat-wishlist-list]";
const emptySelector = "[data-cat-wishlist-empty]";
const drawerSelector = "[data-cat-wishlist-drawer]";
let remoteSyncTimer;
let remoteSyncAvailable = true;
let memoryWishlist = [];
let domSyncTimer;

function readConfig() {
  const configElement = document.getElementById("cat-wishlist-config");
  if (!configElement) return {};

  try {
    const config = JSON.parse(configElement.textContent || "{}");
    return {
      ...config,
      initialItems: normalizeItems(config.initialItems),
    };
  } catch {
    return {};
  }
}

function readWishlist() {
  try {
    const storedItems =
      window.localStorage?.getItem(STORAGE_KEY) ||
      window.localStorage?.getItem(LEGACY_STORAGE_KEY) ||
      "[]";

    return normalizeItems(JSON.parse(storedItems));
  } catch {
    return normalizeItems(memoryWishlist);
  }
}

function writeWishlist(items) {
  const normalizedItems = normalizeItems(items);
  memoryWishlist = normalizedItems;

  try {
    window.localStorage?.setItem(STORAGE_KEY, JSON.stringify(normalizedItems));
    window.localStorage?.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    // Some browser contexts can block storage; keep the session copy working.
  }

  window.dispatchEvent(
    new CustomEvent("cat:wishlist:update", {
      detail: { items: normalizedItems },
    }),
  );
  scheduleRemoteSync(normalizedItems);
}

function getProductFromButton(button) {
  return {
    id: String(button.dataset.productId || ""),
    variantId: String(button.dataset.productVariantId || ""),
    title: button.dataset.productTitle || "",
    url: button.dataset.productUrl || "#",
    image: button.dataset.productImage || "",
    price: button.dataset.productPrice || "",
  };
}

function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function isInWishlist(productId, items = readWishlist()) {
  return items.some((item) => String(item.id) === String(productId));
}

function normalizeItems(items) {
  if (typeof items === "string") {
    try {
      items = JSON.parse(items);
    } catch {
      items = [];
    }
  }

  if (!Array.isArray(items)) return [];

  return items
    .filter((item) => item?.id)
    .map((item) => ({
      id: String(item.id || ""),
      variantId: String(item.variantId || item.variant_id || ""),
      title: String(item.title || ""),
      url: String(item.url || "#"),
      image: String(item.image || ""),
      price: String(item.price || ""),
    }))
    .filter(
      (item, index, allItems) =>
        allItems.findIndex((candidate) => candidate.id === item.id) === index,
    );
}

function mergeWishlistItems(...sources) {
  return normalizeItems(sources.flat()).filter(
    (item, index, allItems) =>
      allItems.findIndex((candidate) => candidate.id === item.id) === index,
  );
}

function syncButtons(items = readWishlist()) {
  document.querySelectorAll(toggleSelector).forEach((button) => {
    const active = isInWishlist(button.dataset.productId, items);
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", String(active));
    button.setAttribute(
      "aria-label",
      active ? "Eliminar de favoritos" : "Agregar a favoritos",
    );
  });

  document.querySelectorAll("[data-cat-wishlist-count]").forEach((target) => {
    target.textContent = items.length > 0 ? String(items.length) : "";
  });
}

function renderWishlist(items = readWishlist()) {
  document.querySelectorAll(listSelector).forEach((list) => {
    const layout = list.dataset.catWishlistLayout || "page";
    const scope =
      list.closest(drawerSelector) ||
      list.closest(".cat-wishlist-page") ||
      document;
    const empty = scope.querySelector(emptySelector);

    if (empty) empty.hidden = items.length > 0;
    list.hidden = items.length === 0;
    list.innerHTML = items
      .map((item) =>
        layout === "drawer" ? renderDrawerItem(item) : renderPageItem(item),
      )
      .join("");
  });
}

function syncWishlistDom() {
  const items = readWishlist();
  syncButtons(items);
  renderWishlist(items);
}

function scheduleWishlistDomSync() {
  window.clearTimeout(domSyncTimer);
  domSyncTimer = window.setTimeout(syncWishlistDom, 0);
}

function setShareButtonLabel(button, label, timeout = 1800) {
  if (!button) return;

  const labelElement = button.querySelector("[data-cat-wishlist-share-label]");
  const originalLabel =
    button.dataset.originalLabel || labelElement?.textContent || button.textContent;
  button.dataset.originalLabel = originalLabel;

  if (labelElement) {
    labelElement.textContent = label;
  } else {
    button.textContent = label;
  }

  if (timeout > 0) {
    window.setTimeout(() => {
      if (labelElement) {
        labelElement.textContent = originalLabel;
      } else {
        button.textContent = originalLabel;
      }
    }, timeout);
  }
}

function showShareUrl(shareUrl) {
  const input = document.querySelector("[data-cat-wishlist-share-url]");
  if (!input) return;

  input.value = shareUrl;
  input.hidden = false;
  input.focus();
  input.select();
}

function renderPageItem(item) {
  const image = item.image
    ? `<a class="cat-wishlist-card__image-link" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy"></a>`
    : `<a class="cat-wishlist-card__image-link cat-wishlist-card__image-link--empty" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}"></a>`;

  return `
    <article class="cat-wishlist-card" data-cat-wishlist-item="${escapeHtml(item.id)}">
      ${image}
      <div class="cat-wishlist-card__content">
        <a class="cat-wishlist-card__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
        ${item.price ? `<p class="cat-wishlist-card__price">${escapeHtml(item.price)}</p>` : ""}
        <div class="cat-wishlist-card__actions">
          <a class="cat-wishlist-card__view" href="${escapeHtml(item.url)}">Ver producto</a>
          <button type="button" class="cat-wishlist-card__remove" data-cat-wishlist-remove="${escapeHtml(item.id)}">Eliminar</button>
        </div>
      </div>
    </article>
  `;
}

function renderDrawerItem(item) {
  const image = item.image
    ? `<a class="cat-wishlist-drawer__image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy"></a>`
    : `<a class="cat-wishlist-drawer__image" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}"></a>`;
  const addButton = item.variantId
    ? `<button type="button" class="cat-wishlist-drawer__add" data-cat-wishlist-cart-add="${escapeHtml(item.variantId)}">Agregar al carrito</button>`
    : `<a class="cat-wishlist-drawer__add" href="${escapeHtml(item.url)}">Ver producto</a>`;

  return `
    <article class="cat-wishlist-drawer__item" data-cat-wishlist-item="${escapeHtml(item.id)}">
      ${image}
      <div class="cat-wishlist-drawer__meta">
        <p class="cat-wishlist-drawer__eyebrow">${escapeHtml([item.price].filter(Boolean).join(" · "))}</p>
        <a class="cat-wishlist-drawer__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
        ${addButton}
      </div>
      <button type="button" class="cat-wishlist-drawer__remove" data-cat-wishlist-remove="${escapeHtml(item.id)}" aria-label="Eliminar ${escapeHtml(item.title)}">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </article>
  `;
}

function removeProduct(productId) {
  const nextItems = readWishlist().filter(
    (item) => String(item.id) !== String(productId),
  );
  writeWishlist(nextItems);
}

async function fetchRemoteWishlist() {
  const config = readConfig();
  if (!config.loggedIn || !config.syncEndpoint || !remoteSyncAvailable)
    return [];

  try {
    const response = await fetch(config.syncEndpoint, {
      headers: {
        Accept: "application/json",
      },
      credentials: "same-origin",
    });

    if (!response.ok) throw new Error("Wishlist endpoint unavailable");

    const data = await response.json();
    return normalizeItems(data.items || data.wishlist || []);
  } catch {
    remoteSyncAvailable = false;
    return [];
  }
}

function scheduleRemoteSync(items) {
  const config = readConfig();
  if (!config.loggedIn || !config.syncEndpoint || !remoteSyncAvailable) return;

  window.clearTimeout(remoteSyncTimer);
  remoteSyncTimer = window.setTimeout(() => persistRemoteWishlist(items), 500);
}

async function persistRemoteWishlist(items) {
  const config = readConfig();
  if (!config.loggedIn || !config.syncEndpoint || !remoteSyncAvailable) return;

  try {
    const response = await fetch(config.syncEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ items: normalizeItems(items) }),
    });

    if (!response.ok) throw new Error("Wishlist endpoint unavailable");
  } catch {
    remoteSyncAvailable = false;
  }
}

async function hydrateWishlist() {
  const config = readConfig();
  const localItems = readWishlist();
  const liquidItems = normalizeItems(config.initialItems || []);
  const remoteItems = await fetchRemoteWishlist();
  const mergedItems = mergeWishlistItems(remoteItems, liquidItems, localItems);

  memoryWishlist = mergedItems;

  try {
    window.localStorage?.setItem(STORAGE_KEY, JSON.stringify(mergedItems));
  } catch {
    // Some browser contexts can block storage; the in-memory list still renders.
  }

  window.dispatchEvent(
    new CustomEvent("cat:wishlist:update", { detail: { items: mergedItems } }),
  );

  if (config.loggedIn && mergedItems.length > 0) {
    scheduleRemoteSync(mergedItems);
  }
}

function openDrawer() {
  const drawer = document.querySelector(drawerSelector);
  if (!drawer) return;

  drawer.hidden = false;
  drawer.setAttribute("aria-hidden", "false");
  document.documentElement.setAttribute("scroll-lock", "");
  renderWishlist();
}

function closeDrawer() {
  const drawer = document.querySelector(drawerSelector);
  if (!drawer) return;

  drawer.hidden = true;
  drawer.setAttribute("aria-hidden", "true");
  document.documentElement.removeAttribute("scroll-lock");
}

function encodeWishlist(items) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(items))));
}

function decodeWishlist(value) {
  return JSON.parse(decodeURIComponent(escape(atob(value))));
}

function importSharedWishlist() {
  const url = new URL(window.location.href);
  const encoded = url.searchParams.get(SHARE_PARAM);
  if (!encoded) return;

  try {
    const sharedItems = decodeWishlist(encoded);
    if (!Array.isArray(sharedItems)) return;

    const currentItems = readWishlist();
    const mergedItems = mergeWishlistItems(sharedItems, currentItems);

    writeWishlist(mergedItems);
    url.searchParams.delete(SHARE_PARAM);
    window.history.replaceState({}, "", url.toString());
    openDrawer();
  } catch {
    // Invalid shared list URLs should fail silently.
  }
}

async function shareWishlist() {
  const items = readWishlist();
  const button = document.querySelector("[data-cat-wishlist-share]");
  if (items.length === 0) {
    setShareButtonLabel(button, "Agrega productos");
    return;
  }

  const shareUrl = `${window.location.origin}/?${SHARE_PARAM}=${encodeURIComponent(encodeWishlist(items))}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: "Mi lista de deseos",
        text: "Te comparto mi lista de deseos.",
        url: shareUrl,
      });
      setShareButtonLabel(button, "Lista compartida");
      return;
    } catch (error) {
      if (error?.name === "AbortError") return;
    }
  }

  try {
    if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
    await navigator.clipboard.writeText(shareUrl);
    showShareUrl(shareUrl);
    setShareButtonLabel(button, "Enlace copiado");
    return;
  } catch {
    const input = document.createElement("textarea");
    input.value = shareUrl;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.left = "-9999px";
    document.body.appendChild(input);
    input.select();

    try {
      const copied = document.execCommand("copy");
      showShareUrl(shareUrl);

      if (copied) {
        setShareButtonLabel(button, "Enlace copiado");
      } else {
        setShareButtonLabel(button, "Copia el enlace");
      }
    } catch {
      showShareUrl(shareUrl);
      window.prompt("Copia el enlace para compartir tu lista", shareUrl);
    } finally {
      input.remove();
    }
  }
}

async function addVariantToCart(variantId, button) {
  if (!variantId) return;

  const originalHtml = button.innerHTML;
  const routesRoot = window.Shopify?.routes?.root || "/";
  const cartAddUrl =
    window.Theme?.routes?.cart_add_url ||
    `${routesRoot.endsWith("/") ? routesRoot : `${routesRoot}/`}cart/add.js`;

  button.disabled = true;
  button.classList.remove(
    "cat-wishlist-drawer__add--added",
    "cat-wishlist-drawer__add--error",
  );

  try {
    const response = await fetch(cartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });

    if (!response.ok) throw new Error("Cart add failed");

    const cartResponse = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = cartResponse.ok ? await cartResponse.json() : null;

    button.classList.add("cat-wishlist-drawer__add--added");
    button.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 12.5 9.5 17 19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Agregado</span>
    `;
    setTimeout(() => {
      button.innerHTML = originalHtml;
      button.classList.remove("cat-wishlist-drawer__add--added");
      button.disabled = false;

      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: "cat-wishlist",
            data: {
              source: "cat-wishlist",
              itemCount: cart?.item_count || 0,
              variantId: String(variantId),
            },
          },
        }),
      );
    }, 1200);
  } catch {
    button.classList.add("cat-wishlist-drawer__add--error");
    button.textContent = "No se pudo agregar";
    setTimeout(() => {
      button.innerHTML = originalHtml;
      button.classList.remove("cat-wishlist-drawer__add--error");
      button.disabled = false;
    }, 1800);
  }
}

document.addEventListener("click", (event) => {
  const opener = event.target.closest("[data-cat-wishlist-open]");
  if (opener) {
    event.preventDefault();
    openDrawer();
    return;
  }

  if (event.target.closest("[data-cat-wishlist-close]")) {
    closeDrawer();
    return;
  }

  const toggle = event.target.closest(toggleSelector);
  if (toggle) {
    event.preventDefault();
    event.stopPropagation();

    const product = getProductFromButton(toggle);
    if (!product.id) return;

    const items = readWishlist();
    const exists = isInWishlist(product.id, items);
    const nextItems = exists
      ? items.filter((item) => String(item.id) !== product.id)
      : [product, ...items];
    writeWishlist(nextItems);
    return;
  }

  const removeButton = event.target.closest("[data-cat-wishlist-remove]");
  if (removeButton) {
    removeProduct(removeButton.dataset.catWishlistRemove);
    return;
  }

  const addButton = event.target.closest("[data-cat-wishlist-cart-add]");
  if (addButton) {
    addVariantToCart(addButton.dataset.catWishlistCartAdd, addButton);
    return;
  }

  if (event.target.closest("[data-cat-wishlist-share]")) {
    event.preventDefault();
    shareWishlist();
  }
});

window.addEventListener("cat:wishlist:update", (event) => {
  syncButtons(event.detail.items);
  renderWishlist(event.detail.items);
});

document.addEventListener("cart:update", () => {
  scheduleWishlistDomSync();
  window.setTimeout(syncWishlistDom, 250);
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeDrawer();
});

document.addEventListener("DOMContentLoaded", () => {
  importSharedWishlist();
  hydrateWishlist();

  const observer = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) => {
        if (!(node instanceof Element)) return false;

        return (
          node.matches?.(
            `${toggleSelector}, [data-cat-wishlist-count], ${listSelector}`,
          ) ||
          Boolean(
            node.querySelector?.(
              `${toggleSelector}, [data-cat-wishlist-count], ${listSelector}`,
            ),
          )
        );
      }),
    );

    if (shouldSync) scheduleWishlistDomSync();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener("shopify:section:load", () => {
  syncWishlistDom();
});
